import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";

const TestFinishConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                {'Confirmar envio da Avaliação'}
            </DialogTitle>

            <DialogContent>
                <DialogContentText>
                    {'Revise suas respostas antes de finalizar. Após a conclusão da avaliação, não será mais possível realizar alterações. Deseja realmente finalizar a avaliação?'}
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    {'Revisar'}
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={onConfirm}
                >
                    {'Enviar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TestFinishConfirmationDialog;